/*
 * followfood: Bundle-Builder Karten-Anreicherung (Phase 2)
 *
 * Easify rendert die Produktkarten clientseitig und liefert KEINE Produktdaten
 * (kein Gewicht/Grundpreis). Wir reichern jede Karte nachtraeglich an:
 *   - Datenquelle: window.ffBundleData (per Liquid aus published Kategorie-Collections)
 *   - Zuordnung:   card[data-product-id] -> ffBundleData[id]
 *   - Gewicht (d.w):     .product-card__weight neben den Preis
 *   - Grundpreis (d.u):  "(X €/kg)" als dezente Zeile unter den Preis
 *   - EUR-Strip:         Easifys "€2,99 EUR" -> "€2,99" (das "EUR" ist Easify-spezifisch;
 *                        die echten Shop-Karten zeigen kein "EUR")
 *
 * Robustheit: MutationObserver fuer Lazy-Rendering + Tab-Wechsel; idempotent
 * (data-ff-enriched + EUR-Strip ist nach Entfernung ein No-Op); debounced (rAF).
 * Hinweis: Observer hoert nur auf childList -> der EUR-Text-Replace (characterData)
 * loest keine neue Observer-Runde aus (kein Loop).
 */
(function () {
  'use strict';

  var DATA = window.ffBundleData || {};
  // Kein Early-Return mehr bei leerer Map: seit Ansatz B werden Karten-Daten (Gewicht/
  // Kilopreis) on-demand über den Handle geholt (window.ffGetProduct), unabhängig davon,
  // ob die Liquid-ID-Map noch passt. Das Skript lädt ohnehin nur auf der Bundle-Seite.
  var I18N = window.ffBundleI18n || {}; // Badge-Texte aus den Locales (#50)
  var CONFIG = window.ffBundleConfig || {}; // Free-Shipping-Schwelle (geteilt mit ff-bundle-sticky, #58)

  // "+"-Icon (Plus im Kreis) aus Figma fuer den ATC-Button; currentColor erbt die Button-Textfarbe
  var ADD_ICON = '<svg class="ff-bundle-add-icon" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M8.86166 6.64567V11.0765M11.0771 8.86108H6.64625M15.5079 8.86108C15.5079 12.5317 12.5323 15.5073 8.86166 15.5073C5.19104 15.5073 2.21542 12.5317 2.21542 8.86108C2.21542 5.19046 5.19104 2.21484 8.86166 2.21484C12.5323 2.21484 15.5079 5.19046 15.5079 8.86108Z" stroke="currentColor" stroke-width="1.10771" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  // entfernt ein abschliessendes " +" aus dem Button-Text (Easify rendert "Hinzufuegen +")
  function stripPlus(el) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      if (/\+\s*$/.test(node.nodeValue)) node.nodeValue = node.nodeValue.replace(/\s*\+\s*$/, '');
    }
  }

  // Normalisiert Easifys Preisformat "€4,29 EUR" auf das Shop-Format
  // "4,29 €" (Betrag + geschütztes Leerzeichen + €). Das Muster ist auf das
  // "EUR"-Suffix verankert (nicht optional): nach der Normalisierung gibt es kein
  // "EUR" mehr → ein erneuter scan()-Lauf matcht nicht (idempotent), und zwei
  // Preise in einem Textknoten (z.B. Streichpreis "€5,99 EUR €4,29 EUR") werden
  // unabhängig korrekt umgesetzt statt sich beim 2. Lauf zu verketten. Unser
  // injizierter "(26,81 €/kg)"-Grundpreis bleibt unberührt (kein "EUR" dahinter).
  function normalizePrice(el) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.indexOf('€') !== -1 || node.nodeValue.indexOf('EUR') !== -1) {
        node.nodeValue = node.nodeValue.replace(/€\s*([\d.,]+)\s*EUR/g, '$1 €');
      }
    }
  }

  // Quantity-Stepper (erscheint nach "Hinzufuegen"-Klick): +/- als blaue Pills.
  // Easify setzt die Button-bg via [sbb-data-box-id] .BUTTON_TS:not(:hover) UNLAYERED
  // !important — das schlaegt unser layered CSS trotz hoeherer Spezifitaet (Cascade:
  // unlayered !important > layered !important). Inline !important schlaegt es zuverlaessig.
  // Layout/Radius/Farbe laufen weiter via followfood.css; nur die bg + Hover hier.
  function styleSteppers() {
    var btns = document.querySelectorAll('.PRODUCT_CARD_QUANTITY_SELECTOR_BUTTON_TS:not([data-ff-stepper])');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      b.setAttribute('data-ff-stepper', '1');
      b.style.setProperty('background-color', 'rgb(var(--ff-button))', 'important');
      b.addEventListener('mouseenter', function () { this.style.setProperty('background-color', 'rgb(var(--ff-text-dark))', 'important'); });
      b.addEventListener('mouseleave', function () { this.style.setProperty('background-color', 'rgb(var(--ff-button))', 'important'); });
      // Icon weiss: SVG nutzt stroke="currentColor", erbt aber Easifys schwarze color
      // (nicht unsere weisse Button-color) -> stroke direkt inline setzen.
      var icons = b.querySelectorAll('svg, line');
      for (var s = 0; s < icons.length; s++) icons[s].style.setProperty('stroke', 'rgb(var(--ff-button-text))', 'important');
    }
  }

  // ATC-Button "Hinzufuegen": Figma-"+"-Icon statt Easifys Text-"+". Laeuft im scan
  // (nicht nur in enrichCard!), weil Easify den Button nach dem Stepper-Zyklus (Minus
  // auf 0) NEU rendert -> "Hinzufuegen +". enrichCard greift dann nicht mehr (Karte ist
  // bereits data-ff-enriched). Idempotent pro Button (.ff-bundle-add-icon vorhanden?).
  function styleAtcButton() {
    // Karten-ATC (.PRODUCT_CARD_ATC_BUTTON_TS) + Quick-View-Overlay-Button
    // (.QUICK_VIEW_ADD_TO_BOX_BUTTON_TS, #50): gleiche "Hinzufuegen +"-Logik (Plus->Icon,
    // 16px Body-Font). Beide rendern Easify nach Interaktion neu -> idempotent pro Button.
    var btns = document.querySelectorAll('.PRODUCT_CARD_ATC_BUTTON_TS, .QUICK_VIEW_ADD_TO_BOX_BUTTON_TS');
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      if (btn.querySelector('.ff-bundle-add-icon')) continue;
      // "+"-Icon IN den Text-Container (direkt hinter "Hinzufuegen"), nicht ans Button-Ende
      // — sonst drueckt der breite Text-Container das Icon an den rechten Rand.
      var content = btn.querySelector('[class*="button_content"]') || btn;
      stripPlus(content);
      content.insertAdjacentHTML('beforeend', ADD_ICON);
      // Schrift wie echte .product-card (16px, Theme-Font) — Easify setzt 18px via el-key.
      content.style.setProperty('font-size', '16px', 'important');
      content.style.setProperty('font-family', 'var(--font-body-family)', 'important');
      btn.style.setProperty('font-size', '16px', 'important');
    }
  }

  // Kategorie-Tabs (ALLES, FISCH & MEERESFRUECHTE ...) an die echten Category-Pills
  // (.ff-category-pills__pill) angleichen. GEMESSEN: die echten Pills sind <a>-Links, und
  // Fontify rendert <a> in Gotham-Book/14px -> Easifys Tab-Default (Gotham) ist hier bereits
  // RICHTIG, nur die GROESSE weicht ab: Easifys Text-Leaf ist 16px, die Pill 14px. Die
  // T3-CSS (0.875rem) greift nur auf den Wrapper, nicht aufs Leaf (gleiche Spezifitaets-
  // Huerde wie bei der Font) -> font-size per JS-inline je Pill + Nachkommen. Font-Family
  // bewusst NICHT anfassen (Easify-Gotham == Fontifys Pill-Font). setProperty loest nur
  // attribute-, keine childList-Mutation aus -> kein Observer-Loop; idempotent, faengt
  // auch Easifys Tab-Re-Render.
  // Hex (#c84233) -> "200 66 51" fuer rgb(var(--ff-pill)) in followfood.css
  function hexToRgbTriplet(hex) {
    if (!hex) return null;
    var h = String(hex).replace('#', '').trim();
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    if (h.length !== 6) return null;
    var n = parseInt(h, 16);
    if (isNaN(n)) return null;
    return ((n >> 16) & 255) + ' ' + ((n >> 8) & 255) + ' ' + (n & 255);
  }

  // Kategorie-Akzentfarbe je Tab aus window.ffCatColors (Metafield-Quelle, s. ff-bundle-cards.liquid).
  // Match: Tab-Label (lowercase) == Collection-Title ODER einer ist Prefix des anderen
  // ("SNACKS" -> "snacks & eis"; "ALLES" -> kein Match -> Brand-Default #304960).
  // Ersetzt die alte nth-child-Zuordnung (positionsabhaengig, driftete bei Umsortierung der Tabs).
  var FF_TAB_DEFAULT = '48 73 96'; // #304960 Brand-dark (= "Alle"/Default-Pille)
  function tabColorFor(label) {
    var colors = window.ffCatColors || {};
    label = (label || '').trim().toLowerCase();
    if (label.length < 2) return null;
    for (var key in colors) {
      if (key === label || key.indexOf(label) === 0 || label.indexOf(key) === 0) {
        return hexToRgbTriplet(colors[key]) || FF_TAB_DEFAULT;
      }
    }
    return FF_TAB_DEFAULT;
  }

  function styleTabs() {
    var pills = document.querySelectorAll('[class~="style1Header__item"]');
    for (var i = 0; i < pills.length; i++) {
      var nodes = [pills[i]].concat([].slice.call(pills[i].querySelectorAll('*')));
      for (var n = 0; n < nodes.length; n++) nodes[n].style.setProperty('font-size', '0.875rem', 'important');
      var triplet = tabColorFor(pills[i].textContent);
      if (triplet) pills[i].style.setProperty('--ff-pill', triplet, 'important');
    }
  }

  // Titel-Farbe (#4E7292) + Font (Body-Token = Gotham-Book) fuer ALLE Karten — datenUNABHAENGIG.
  // Lag frueher in enrichCard() HINTER dem "if (!d) return": Karten ohne ffBundleData-Match
  // (z.B. ein Produkt jenseits des 50-Loop-Limits) blieben so schwarz/Easify-Default. Gehoert
  // daher in den scan, je Element idempotent (setProperty) -> faengt auch Easifys Re-Render.
  // Easify-Default-Titel ist schwarz; echte .product-card__title nutzen Body-Token + #4E7292.
  function styleCardTexts() {
    var titles = document.querySelectorAll('.PRODUCT_CARD_TITLE_TS');
    for (var i = 0; i < titles.length; i++) {
      titles[i].style.setProperty('color', '#4E7292', 'important');
      titles[i].style.setProperty('font-family', 'var(--font-body-family)', 'important');
    }
    var prices = document.querySelectorAll('.PRODUCT_CARD_PRICE_LIST_TS');
    for (var j = 0; j < prices.length; j++) {
      prices[j].style.setProperty('font-family', 'var(--font-body-family)', 'important');
    }
  }

  // Sticky-Bar (Quick Summary, Footer): Schrift auf Body-Token (= Gotham-Book) wie die Karten.
  // Easify erzwingt eigene Font via BODY_FONT_FAMILY_TS/el-key -> CSS greift nicht (gemessen),
  // nur JS-inline. Je Element + Nachkommen idempotent (setProperty) -> faengt Easifys
  // Re-Render der Bar. Layout/Farbe/Radius der Bar laufen via followfood.css.
  function styleSummary() {
    var sels = ['.QUICK_SUMMARY_HEADER_TEXT_TS', '.QUICK_SUMMARY_CONTENT_TEXT_TS', '.QUICK_SUMMARY_BUTTON_NEXT_TS'];
    for (var s = 0; s < sels.length; s++) {
      var els = document.querySelectorAll(sels[s]);
      for (var i = 0; i < els.length; i++) {
        els[i].style.setProperty('font-family', 'var(--font-body-family)', 'important');
        var kids = els[i].querySelectorAll('*');
        for (var k = 0; k < kids.length; k++) kids[k].style.setProperty('font-family', 'var(--font-body-family)', 'important');
      }
    }
  }

  function enrichCard(card) {
    if (!card || card.dataset.ffEnriched) return;
    var id = card.getAttribute('data-product-id');
    if (!id) return;

    var price = card.querySelector('.PRODUCT_CARD_PRICE_LIST_TS');
    if (!price) return; // Preis noch nicht gerendert

    // Gewicht/Kilopreis: bevorzugt aus der Liquid-Map (bekannte Produkte), sonst on-demand
    // über den Handle (Ansatz B — importfest). Solange der Fetch läuft: kein Flag, nächster scan reichert an.
    var d = DATA[id];
    if (!d || (!d.w && !d.u)) {
      var handle = window.ffCardHandle && window.ffCardHandle(card);
      if (handle && window.ffGetProduct) {
        var pd = window.ffGetProduct(handle, scheduleScan);
        if (pd === null) return; // Fetch läuft -> retry im nächsten scan
        d = { w: (d && d.w) || pd.w, u: (d && d.u) || pd.u };
      }
    }
    if (!d) return; // weder Map noch Handle -> kein Flag, evtl. spaeter nachladbar

    card.dataset.ffEnriched = '1';

    // Body-Token (= Gotham-Book) statt Easifys Default — restlicher Shop und echte
    // .product-card nutzen den Token. Wird je Text-Element gesetzt (Easify setzt eigene Font
    // auf einen Zwischen-Container, daher reicht eine Container-Font nicht — s. unten).
    var ffFont = 'var(--font-body-family)';

    // (Titel-Farbe/-Font laufen jetzt datenUNABHAENGIG in styleCardTexts() im scan — sonst
    //  blieben ungematchte Karten schwarz.)

    // Preis-Row: links [Preis + Grundpreis inline], rechts [Gewicht]
    var row = document.createElement('div');
    row.className = 'ff-bundle-price-row';
    price.parentNode.insertBefore(row, price);

    var left = document.createElement('span');
    left.className = 'ff-bundle-price-group';
    row.appendChild(left);
    left.appendChild(price);

    // Grundpreis "(X €/kg)" klein neben dem Preis (wie .product-card .unit-price)
    if (d.u) {
      var unit = document.createElement('span');
      unit.className = 'unit-price ff-bundle-unit-price';
      unit.textContent = '(' + d.u + ')';
      left.appendChild(unit);
    }

    // Gewicht rechts
    if (d.w) {
      var weight = document.createElement('span');
      weight.className = 'product-card__weight ff-bundle-weight';
      weight.textContent = d.w;
      row.appendChild(weight);
    }

    // (ATC-Button "+"-Icon: s. styleAtcButton() im scan — muss bei Easify-Re-Render greifen)

    // Body-Token (= Gotham-Book) fuer die HIER erzeugten datenabhaengigen Elemente (Gewicht/Grundpreis).
    // Titel/Preis laufen datenUNABHAENGIG in styleCardTexts(), der Button in styleAtcButton().
    var texts = card.querySelectorAll('.ff-bundle-weight,.ff-bundle-unit-price');
    for (var ti = 0; ti < texts.length; ti++) {
      texts[ti].style.setProperty('font-family', ffFont, 'important');
    }
  }

  // Easify Review-Checkout-Button ("In den Warenkorb"): das 🛒-Emoji im Label
  // durch das echte SVG-Cart-Icon ersetzen (konsistent mit der Sticky-CTA, Regel
  // "keine Emojis, Icons als SVG"). Idempotent: Emoji-Strip nur bei Vorkommen,
  // SVG nur wenn noch keins da (Guard .ff-cart-icon AM Element → übersteht Easify-
  // Re-Renders, die den Button neu erzeugen). Hook: BOX_REVIEW_PAGE_CHECKOUT_BUTTON_TS.
  function fixReviewCartIcon() {
    var btns = document.querySelectorAll('.BOX_REVIEW_PAGE_CHECKOUT_BUTTON_TS');
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      var span = btn.querySelector('[class*="button_content_text"]');
      if (span && span.textContent.indexOf('🛒') !== -1) {
        span.textContent = span.textContent.replace(/\s*🛒\s*/g, '').trim();
      }
      var content = btn.querySelector('[class*="button_content"]') || btn;
      if (content && !content.querySelector('.ff-cart-icon')) {
        var NS = 'http://www.w3.org/2000/svg';
        var svg = document.createElementNS(NS, 'svg');
        svg.setAttribute('class', 'ff-cart-icon');
        svg.setAttribute('width', '18');
        svg.setAttribute('height', '18');
        svg.setAttribute('viewBox', '0 0 24 24');
        svg.setAttribute('stroke', 'currentColor');
        svg.setAttribute('fill', 'none');
        svg.setAttribute('aria-hidden', 'true');
        var path = document.createElementNS(NS, 'path');
        path.setAttribute('stroke-linecap', 'round');
        path.setAttribute('stroke-linejoin', 'round');
        path.setAttribute('d', 'M1 1h.5v0c.226 0 .339 0 .44.007a3 3 0 0 1 2.62 1.976c.034.095.065.204.127.42l.17.597m0 0 1.817 6.358c.475 1.664.713 2.496 1.198 3.114a4 4 0 0 0 1.633 1.231c.727.297 1.592.297 3.322.297h2.285c1.75 0 2.626 0 3.359-.302a4 4 0 0 0 1.64-1.253c.484-.627.715-1.472 1.175-3.161l.06-.221c.563-2.061.844-3.092.605-3.906a3 3 0 0 0-1.308-1.713C19.92 4 18.853 4 16.716 4H4.857ZM12 20a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm8 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z');
        svg.appendChild(path);
        content.appendChild(svg);
      }
    }
  }

  // Easify zeigt den Rabatt-Prozentsatz aus Rabattbetrag÷Zwischensumme gerechnet
  // (cent-gerundet) → "Rabatt (15.01%)" statt des glatten Tier-Werts. Den
  // angezeigten Prozentsatz in der Review-Summary auf die ganze Zahl runden
  // ("15.01%"→"15%"). Scope: nur der Summary-Kasten (über den Checkout-Button-
  // Vorfahren bis "ZUSAMMENFASSUNG"), damit andere %-Angaben unberührt bleiben.
  // Idempotent: "15%" ohne Nachkommastelle matcht das Muster nicht erneut.
  function cleanDiscountPct() {
    // Easify rendert das Label als <span class="…discount_percentage…"> (10.01%)</span>.
    // Direkt diesen Span ansteuern (textContent ist ein einzelner Knoten) und „X.XX%"
    // auf die ganze Zahl runden. Persistiert (React revertet das gesetzte textContent
    // nicht), idempotent („15%" ohne Nachkommastelle matcht nicht erneut).
    var spans = document.querySelectorAll('[class*="discount_percentage"]');
    for (var i = 0; i < spans.length; i++) {
      var s = spans[i];
      if (/\d+[.,]\d+\s*%/.test(s.textContent)) {
        s.textContent = s.textContent.replace(/(\d+)[.,](\d+)\s*%/g, function (m, a, b) {
          return Math.round(parseFloat(a + '.' + b)) + '%';
        });
      }
    }
  }

  // Box-Review-Seite (#55): Abschluss-Flow verbessern. Zwei DOM-Injektionen in die
  // Zusammenfassungs-Box (orderDetail__summary_checkout):
  //   (a) Hinweis „…kannst du deine Kiste nicht mehr bearbeiten" ÜBER den CTA-Buttons.
  //   (b) Neuer Sekundär-Button „In den Warenkorb legen und neue Kiste erstellen": legt die
  //       Kiste über Easifys eigenen Checkout-Button in den Warenkorb (Easify redirectet
  //       danach auf /cart) und setzt sessionStorage ffNewBoxAfterCart='1'. Der Guard in
  //       theme.liquid schickt von /cart sofort zurück zum Builder → frische, leere Kiste.
  // Der native „Kiste verwerfen & neu erstellen"-Button (BOX_REVIEW_PAGE_CREATE_NEW_BOX_BUTTON_TS)
  // wird per followfood.css ausgeblendet (display:none) — bleibt klickbar, brauchen wir hier aber nicht.
  // Idempotent: Guards via .ff-review-hint / .ff-review-newbox AM Element (Easify/React re-rendert
  // den Button-Wrap → Flag UND Markup verschwinden zusammen → sauberer Re-Inject, sonst No-Op).
  // EUR-Formatter, identisch zu ff-bundle-sticky.js → gleiche Schreibweise beider Hinweise
  function formatEUR(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function enrichBoxReview() {
    var wrap = document.querySelector('[class*="summary_btn_wrap"]');
    if (!wrap) return;
    var box = wrap.parentNode;
    if (!box) return;

    // (a) Hinweis über den Buttons (zwischen Summen-Block und Button-Wrap)
    if (I18N.reviewCartLockHint && !box.querySelector('.ff-review-hint')) {
      var hint = document.createElement('p');
      hint.className = 'ff-review-hint';
      hint.textContent = I18N.reviewCartLockHint;
      box.insertBefore(hint, wrap);
    }

    // (b) Neuer Sekundär-Button hinter dem Checkout-Button
    var checkout = wrap.querySelector('.BOX_REVIEW_PAGE_CHECKOUT_BUTTON_TS');
    if (I18N.reviewAddAndNewBox && checkout && !wrap.querySelector('.ff-review-newbox')) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ff-review-newbox';
      btn.textContent = I18N.reviewAddAndNewBox;
      btn.addEventListener('click', function () {
        try { sessionStorage.setItem('ffNewBoxAfterCart', '1'); } catch (e) {}
        var co = document.querySelector('.BOX_REVIEW_PAGE_CHECKOUT_BUTTON_TS');
        if (co) co.click();
      });
      if (checkout.nextSibling) wrap.insertBefore(btn, checkout.nextSibling);
      else wrap.appendChild(btn);
    }

    // (d) „Free gift"-Label unterm Gratis-Produkt eindeutschen: der String ist in
    // Easifys React hardcoded — general_translation (App-Admin → Translations) hat
    // KEIN Feld dafür (komplette Key-Liste geprüft 2026-07-16). Die Klasse ist die
    // generische Varianten-Zeile, daher nur bei exaktem Text-Match ersetzen; die
    // Ersetzung selbst ist der Idempotenz-Guard (ersetzter Text matcht nicht mehr,
    // Easify-Re-Render bringt ihn englisch zurück → nächster Scan ersetzt erneut).
    if (I18N.reviewFreeGiftLabel) {
      var giftLabels = document.querySelectorAll('[class*="summary_content_list_variant_product"]');
      for (var gi = 0; gi < giftLabels.length; gi++) {
        if (/^free\s?gift$/i.test((giftLabels[gi].textContent || '').trim())) {
          giftLabels[gi].textContent = I18N.reviewFreeGiftLabel;
        }
      }
    }

    // (c) „Bundle anpassen"-Button (#61): prominenter Proxy auf Easifys kleinen
    // Stift-Link in der Kisten-Zeile (summary_btn_edit) — führt zurück in den
    // bearbeitbaren Builder (step=0), Kiste bleibt intakt.
    if (I18N.reviewEditBox && !wrap.querySelector('.ff-review-edit')) {
      var editSrc = document.querySelector('[class*="summary_btn_edit"]');
      if (editSrc) {
        var editBtn = document.createElement('button');
        editBtn.type = 'button';
        editBtn.className = 'ff-review-edit';
        editBtn.textContent = I18N.reviewEditBox;
        editBtn.addEventListener('click', function () {
          // ⚠ Easify vergibt summary_btn_edit an „Anpassen" UND „Löschen" (verifiziert
          // 2026-07-11) — Text-Match zuerst, DOM-Reihenfolge (Anpassen zuerst) nur als
          // Fallback. Falscher Treffer würde die Kiste verwerfen statt bearbeiten.
          var els = Array.prototype.slice.call(document.querySelectorAll('[class*="summary_btn_edit"]'));
          var src = els.filter(function (e) { return /anpassen|bearbeiten|edit/i.test(e.textContent || ''); })[0] || els[0];
          if (!src) return;
          // Easify-cosmetic-Pattern: der [role=button]-Wrapper trägt den Klick.
          var target = src.closest('[role=button]') || src;
          target.click();
        });
        // „Kiste anpassen" VOR „…neue Kiste erstellen" (Kundenwunsch 2026-07-16):
        // Anpassen ist die häufigere Aktion und gehört direkt unter den Haupt-CTA.
        var newboxBtn = wrap.querySelector('.ff-review-newbox');
        if (newboxBtn) wrap.insertBefore(editBtn, newboxBtn);
        else wrap.appendChild(editBtn);
      }
    }

    // (e) Free-Shipping-Hinweis DIREKT ÜBER „Kiste anpassen" (Kundenwunsch 2026-07-16,
    // vorher Banner in voller Grid-Breite): Info + Aktion gehören zusammen — wer die
    // Schwelle noch nicht erreicht hat, passt die Kiste an. Auf der Review-Seite ist
    // die Sticky-Bar (#58) ausgeblendet, daher hier nochmal. Basis = Easifys „Gesamt"
    // (summary_checkout_price_total, nach Rabatt) — gleiche Parse-Logik wie der Sticky.
    // Läuft NACH Block (c), damit .ff-review-edit als Anker existiert. textContent-
    // Update je Scan ist idempotent; Element-Guard via querySelector (Re-Render
    // entfernt den Wrap-Inhalt → Neuanlage beim nächsten Scan).
    if (CONFIG.freeShippingThresholdCents > 0 && I18N.freeShippingRemaining) {
      var totalEl = document.querySelector('[class*="summary_checkout_price_total"]');
      var m = totalEl && (totalEl.textContent || '').match(/€\s*([\d.,]+)/);
      var ship = wrap.querySelector('.ff-review-shipping');
      // deutsche Notation (€1.234,56) — wie ff-bundle-sticky.js
      var totalCents = m ? Math.round(parseFloat(m[1].replace(/\./g, '').replace(',', '.')) * 100) : 0;
      if (totalCents > 0) {
        if (!ship) {
          ship = document.createElement('p');
          ship.className = 'ff-review-shipping';
          var anchor = wrap.querySelector('.ff-review-edit') || wrap.querySelector('.ff-review-newbox');
          if (anchor) wrap.insertBefore(ship, anchor);
          else wrap.appendChild(ship);
        }
        var remaining = CONFIG.freeShippingThresholdCents - totalCents;
        if (remaining > 0) {
          ship.textContent = (I18N.freeShippingRemaining || '').replace('__AMT__', formatEUR(remaining));
          ship.classList.remove('is-reached');
        } else {
          ship.textContent = I18N.freeShippingReached || '';
          ship.classList.add('is-reached');
        }
      } else if (ship) {
        ship.remove(); // kein/leeres Total (leere Kiste) → Hinweis weg, wie Sticky bei count 0
      }
    }
  }

  // ── Quick-View-Overlay (Produkt-Detail-Popup, #50) ─────────────────────────
  // Easify rendert beim Klick auf PRODUCT_CARD_VIEW_BUTTON_TS ein <aside>-Overlay mit
  // Titel/Preis/Stepper/Add-Button/Beschreibung — aber OHNE followfood-Infos (Subtitle,
  // Gewicht, Kilopreis, Verfügbarkeits-/Neu-/Label-Badges) und im Easify-Default-Look.
  // Wir reichern an (Datenquelle = window.ffBundleData, Match per Produkt-ID aus dem
  // Quantity-Input id="gid://shopify/Product/<ID>"). Die Beschreibung liefert Easify
  // bereits selbst (collapsible "Details") -> wird nur im Look angeglichen, nicht injiziert.
  //
  // Idempotenz: Look (Titel/Preis/Button) läuft datenUNABHÄNGIG je scan (setProperty,
  // idempotent) -> fängt Easifys Re-Render bei Varianten-Wechsel. Die DOM-Injektion
  // (Badges/Subtitle/Gewicht) ist durch data-ff-qv-enriched auf dem Easify-Content-
  // Element + Existenz der .ff-qv-* Elemente geschützt: rendert Easify den Content neu,
  // ist Flag UND Markup weg -> re-enrich; bleibt der Content, ist beides da -> No-Op.

  // Badge-Pille im PDP-Look (outlined: transparent + Border + Status-Punkt bzw. gefüllt)
  function makeQvBadge(text, mod, bgColor) {
    var span = document.createElement('span');
    span.className = 'ff-qv-badge ff-qv-badge--' + mod;
    if (mod === 'online' || mod === 'offline') {
      var dot = document.createElement('span');
      dot.className = 'ff-badge-dot';
      span.appendChild(dot);
    }
    span.appendChild(document.createTextNode(text));
    // label_color (theme.label_color) soll das CSS-!important-Fallback schlagen -> inline important
    if (bgColor) {
      span.style.setProperty('background-color', bgColor, 'important');
      span.style.setProperty('border-color', bgColor, 'important');
    }
    return span;
  }

  function buildQvBadges(d) {
    var wrap = document.createElement('div');
    wrap.className = 'ff-qv-badges';
    // Verfügbarkeit (immer): online grün / offline ("Im Supermarkt") hellblau
    if (d.o === 0) wrap.appendChild(makeQvBadge(I18N.offline || 'Im Supermarkt', 'offline'));
    else wrap.appendChild(makeQvBadge(I18N.online || 'Online verfügbar', 'online'));
    // Neu
    if (d.n) wrap.appendChild(makeQvBadge(I18N.neu || 'Neu!', 'neu'));
    // theme.label (z.B. MSC) mit eigener Label-Farbe
    if (d.l && d.l.length) {
      for (var i = 0; i < d.l.length; i++) wrap.appendChild(makeQvBadge(d.l[i], 'label', d.lc));
    }
    return wrap;
  }

  // PDP-Inhalte (Zertifizierungs-Siegel + Detail-Tabs) aus der echten PDP ins Overlay (#50).
  // Easify liefert diese Metafeld-reichen Blöcke nicht. Wir laden die echte Produktseite per
  // fetch (same-origin, first-party) und übernehmen: das Siegel (.product-siegel-wrap, z.B. MSC)
  // unter dem Button und die ff-product-detail-section__tabs-column (native <details>-Accordions
  // + inline <style>) darunter. Accordion-Hülle stylet sich über die globalen
  // .ff-product-detail-section__* Regeln; die auf .product__info gescopten Siegel-Styles werden
  // im .ff-qv-siegel-Scope repliziert. Pro Handle gecacht ({tabs, siegel}); Race-Schutz, falls
  // der Nutzer das Overlay vor Fetch-Ende auf ein anderes Produkt wechselt.
  var ffPdpCache = {};
  var ffPdpPending = {}; // verhindert Doppel-Fetch derselben PDP während der Fetch läuft (kein content-Guard mehr)
  function injectPdpTabs(ov, content, id, handle) {
    if (!handle || content.querySelector('.ff-qv-pdp-tabs')) return;

    // Easifys eigene "Details" (product.description) ist bereits per CSS ausgeblendet
    // (kein Flash beim Öffnen). Liefert der Fetch keine PDP-Tabs, blenden wir sie über
    // .ff-qv-desc-keep wieder ein (Fallback — sonst stünde gar keine Beschreibung da).
    function keepEasifyDesc() {
      var e = content.querySelector('[class*="product_content_description"]');
      if (e) e.classList.add('ff-qv-desc-keep');
    }
    function importInto(html, sel, className) {
      var node = new DOMParser().parseFromString(html, 'text/html').querySelector(sel);
      if (!node) return null;
      var wrap = document.createElement('div');
      wrap.className = className;
      wrap.appendChild(document.importNode(node, true));
      return wrap;
    }

    // data = { tabs: <html|''>, siegel: <html|''> }
    function doInject(data) {
      if (!data) return;
      var qi = ov.querySelector('input[name="quantity"]');
      var curId = qi ? (qi.id.match(/Product\/(\d+)/) || [])[1] : null;
      if (curId !== id) return;             // Produkt gewechselt -> anderes Overlay
      if (!data.tabs) keepEasifyDesc();     // kein Beschreibungs-Tab -> Easify-Beschreibung als Fallback

      // Zertifizierungs-Siegel (z.B. MSC) — unter dem Button, ÜBER den Tabs (zuerst angehängt)
      if (data.siegel && !content.querySelector('.ff-qv-siegel')) {
        var sw = importInto(data.siegel, '.product-siegel-wrap, .product-siegel', 'ff-qv-siegel');
        if (sw) content.appendChild(sw);
      }
      // Detail-Tabs
      if (data.tabs && !content.querySelector('.ff-qv-pdp-tabs')) {
        var tw = importInto(data.tabs, '.ff-product-detail-section__tabs-column', 'ff-qv-pdp-tabs');
        if (tw) {
          tw.setAttribute('lang', 'de'); // hyphens:auto braucht die Sprache für dt. Silbentrennung
          // Accordions initial zuklappen — die PDP rendert einen Tab per block.settings.opened offen.
          var openTabs = tw.querySelectorAll('details[open]');
          for (var oi = 0; oi < openTabs.length; oi++) openTabs[oi].removeAttribute('open');
          content.appendChild(tw);
        }
      }
    }

    if (ffPdpCache[handle] !== undefined) { doInject(ffPdpCache[handle]); return; }
    if (ffPdpPending[handle]) return; // Fetch läuft bereits (anderer enrichQuickView-Tick)
    ffPdpPending[handle] = true;
    fetch('/products/' + handle, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var data = { tabs: '', siegel: '' };
        if (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var c = doc.querySelector('.ff-product-detail-section__tabs-column');
          data.tabs = c ? c.outerHTML : '';
          var s = doc.querySelector('.product-siegel-wrap') || doc.querySelector('.product-siegel');
          data.siegel = s ? s.outerHTML : '';
        }
        ffPdpCache[handle] = data;
        doInject(data);
      })
      .catch(function () { ffPdpCache[handle] = { tabs: '', siegel: '' }; keepEasifyDesc(); });
  }

  // Produkt-Handle aus Easifys eigenen React-Daten lesen (#50). Nötig für Produkte, die NICHT
  // in window.ffBundleData sind (z.B. "Only Bundle Builder"-Artikel, die in keiner Liquid-
  // Collection auftauchen) -> dort fehlt der Handle, ohne den die PDP-Tabs nicht laden würden.
  // Easify hält pro Overlay ein Produkt-Objekt mit { id: "gid://…/<ID>", handle } in den React-
  // Props. Wir laufen die Fiber hoch und nehmen das Objekt, dessen id zur Overlay-Produkt-ID passt.
  // Defensiv (try/catch): bricht Easifys Struktur, liefert es null -> Fallback = Easify-Beschreibung.
  function ffReadHandle(el, id) {
    try {
      var key = null, ks = Object.keys(el);
      for (var i = 0; i < ks.length; i++) { if (ks[i].indexOf('__reactFiber$') === 0 || ks[i].indexOf('__reactInternalInstance$') === 0) { key = ks[i]; break; } }
      var node = key ? el[key] : null, hops = 0;
      while (node && hops < 60) {
        var bags = [node.memoizedProps, node.pendingProps, node.memoizedState];
        for (var b = 0; b < bags.length; b++) {
          var bag = bags[b];
          if (bag && typeof bag === 'object') {
            for (var pk in bag) {
              var v = bag[pk];
              if (v && typeof v === 'object' && typeof v.handle === 'string' && v.handle && v.handle.indexOf('gid:') === -1 && (!id || (v.id && String(v.id).indexOf(id) !== -1))) return v.handle;
            }
          }
        }
        node = node.return || null; hops++;
      }
    } catch (e) {}
    return null;
  }

  function enrichQuickView() {
    var overlays = document.querySelectorAll('aside[class*="dialog__root"]');
    for (var i = 0; i < overlays.length; i++) {
      var ov = overlays[i];

      // Look (datenUNABHÄNGIG, jeder scan): Titel/Preis #4E7292 + Body-Font + bold,
      // Preis aufs Shop-Format normalisieren ("€3,49 EUR" -> "3,49 €").
      var titleEl = ov.querySelector('[class*="price_information_title"]');
      if (titleEl) {
        titleEl.style.setProperty('color', '#4E7292', 'important');
        titleEl.style.setProperty('font-family', 'var(--font-body-family)', 'important');
        titleEl.style.setProperty('font-weight', '700', 'important');
      }
      var priceEl = ov.querySelector('[class*="price_information_price"]');
      if (priceEl) {
        normalizePrice(priceEl);
        priceEl.style.setProperty('color', '#4E7292', 'important');
        priceEl.style.setProperty('font-family', 'var(--font-body-family)', 'important');
        priceEl.style.setProperty('font-weight', '700', 'important');
      }
      // Beschreibungs-Heading "Details" + Text auf Body-Font/Farbe (Easify-Default angleichen)
      var descTexts = ov.querySelectorAll('[class*="modal_description"], [class*="collapsible_title_text"]');
      for (var t = 0; t < descTexts.length; t++) {
        descTexts[t].style.setProperty('font-family', 'var(--font-body-family)', 'important');
      }

      // DOM-Injektion. Jede Einfügung ist idempotent (prüft auf ihr .ff-qv-*-Element), daher KEIN
      // content-weites Guard-Flag: so kann der ffGetProduct-Callback (unten) Subtitle/Gewicht/
      // Kilopreis nachtragen, sobald die on-demand-Daten (product.js) eintreffen — auch wenn sie
      // beim Öffnen des Overlays noch nicht gecacht waren (z.B. Karte einer gerade gewechselten
      // Kategorie). Sonst blieb die Beschreibung „bei einigen" leer.
      var content = ov.querySelector('[class~="modalDetailProduct__product_content"]');
      if (!content) continue;

      var qInput = ov.querySelector('input[name="quantity"]');
      var id = qInput ? (qInput.id.match(/Product\/(\d+)/) || [])[1] : null;
      var d = id ? DATA[id] : null;
      // Handle für die PDP-Tabs: bevorzugt aus ffBundleData (d.h), sonst aus Easifys React-Daten
      // (für Bundle-only-Produkte ohne ffBundleData-Eintrag). So lädt die Detail-Ansicht für ALLE.
      var handle = (d && d.h) || ffReadHandle(ov, id);

      // Einfüge-Anker: Easify rendert das Overlay PROGRESSIV — der product_content-Container
      // erscheint, bevor Header/Titel/Preis-Wrap fertig sind. Erst weitermachen, wenn alle da sind
      // (der nächste Tick/Callback holt es nach).
      var header = ov.querySelector('[class~="modalDetailProduct__modal_header"]');
      var priceWrap = ov.querySelector('[class*="modal_price_wrap"]');
      if (!header || !titleEl || !priceWrap) continue;

      // Detail-Ansicht: PDP-Tabs + Siegel aus der echten PDP nachladen (braucht nur den Handle,
      // NICHT ffBundleData) -> ersetzt Easifys Default-Beschreibung für jedes Produkt. Ohne Handle
      // (Fallback) bleibt Easifys Beschreibung sichtbar (.ff-qv-desc-keep hebt die CSS-Ausblendung auf).
      if (handle) {
        injectPdpTabs(ov, content, id, handle);
      } else {
        var edKeep = content.querySelector('[class*="product_content_description"]');
        if (edKeep) edKeep.classList.add('ff-qv-desc-keep');
      }

      // Badges: nur mit ffBundleData (Metafelder online/offline/neu/label — nicht in product.js).
      if (d && header.parentNode && !ov.querySelector('.ff-qv-badges')) {
        header.parentNode.insertBefore(buildQvBadges(d), header);
      }
      // Subtitle + Gewicht/Kilopreis: aus ffBundleData ODER on-demand über den Handle (Ansatz B,
      // importfest). Subtitle-Fallback = product.js-Kurzbeschreibung (pd.desc), wenn kein
      // custom.subtitle-Metafeld vorliegt. pd ist i.d.R. schon gecacht (Karten-Anreicherung).
      // Callback = enrichQuickView: trifft die on-demand-Beschreibung erst nach dem Öffnen ein,
      // wird die Anreicherung erneut ausgeführt und Subtitle/Meta nachgetragen (idempotent).
      var pd = handle && window.ffGetProduct ? window.ffGetProduct(handle, enrichQuickView) : null;
      var subText = (d && d.s) || (pd && pd.desc);
      var uVal = (d && d.u) || (pd && pd.u);
      var wVal = (d && d.w) || (pd && pd.w);
      if (subText && titleEl && titleEl.parentNode && !ov.querySelector('.ff-qv-subtitle')) {
        var sub = document.createElement('p');
        sub.className = 'ff-qv-subtitle';
        sub.textContent = subText;
        titleEl.parentNode.insertBefore(sub, titleEl.nextSibling);
      }
      if ((wVal || uVal) && !ov.querySelector('.ff-qv-price-meta')) {
        var meta = document.createElement('div');
        meta.className = 'ff-qv-price-meta';
        if (uVal) {
          var unit = document.createElement('span');
          unit.className = 'ff-qv-unit';
          unit.textContent = '(' + uVal + ')';
          meta.appendChild(unit);
        }
        if (wVal) {
          var weight = document.createElement('span');
          weight.className = 'ff-qv-weight';
          weight.textContent = wVal;
          meta.appendChild(weight);
        }
        priceWrap.appendChild(meta);
      }
    }
  }

  // ── Eigene Kategorie-Filter-Pills (ersetzen Easifys native Tabs) ──────────────
  // Easifys Tabs laden je eine SEPARATE Collection → dasselbe Produkt hat je Tab andere
  // IDs → beim Wechsel "Hinzufügen"-Button statt Stepper (Auswahl scheinbar weg). Wir bleiben
  // immer auf "Alle" (alle Produkte gerendert) und filtern die Karten CLIENT-SEITIG per
  // Produkt-Tag (aus dem React-Fiber der Karte) — kein Collection-Wechsel, Auswahl bleibt.
  // Kategorien fest (= aktuelle Tabs); label = Anzeige, tag = Filter-Tag (leer = alle).
  var FF_FILTER_CATS = [
    { label: 'Alle', tag: '' },
    { label: 'Fisch & Meeresfrüchte', tag: 'Fisch & Meeresfrüchte' },
    { label: 'Fertiggerichte', tag: 'Fertiggerichte' },
    { label: 'Snacks', tag: 'Snacks & Eis' },
    { label: 'Vorrat & Saucen', tag: 'Vorrat & Saucen' }
  ];
  var ffActiveCat = '';
  var ffPriming = false; // true während ffPrimeAllCards scrollt -> Filter aussetzen (Grid voll hoch)
  window.ffPidTags = window.ffPidTags || {};

  // Produkt-Tags einer Karte aus dem React-Fiber (das Produkt-Objekt trägt .tags + .handle).
  function ffCardTags(card) {
    var id = card.getAttribute('data-product-id');
    if (id && window.ffPidTags[id]) return window.ffPidTags[id];
    try {
      var key = null, ks = Object.keys(card);
      for (var i = 0; i < ks.length; i++) { if (ks[i].indexOf('__reactFiber$') === 0 || ks[i].indexOf('__reactInternalInstance$') === 0) { key = ks[i]; break; } }
      var node = key ? card[key] : null, hops = 0;
      while (node && hops < 60) {
        var bags = [node.memoizedProps, node.pendingProps];
        for (var b = 0; b < bags.length; b++) {
          var bag = bags[b];
          if (bag && typeof bag === 'object') { for (var pk in bag) { var v = bag[pk]; if (v && typeof v === 'object' && Array.isArray(v.tags) && typeof v.handle === 'string') { if (id) window.ffPidTags[id] = v.tags; return v.tags; } } }
        }
        node = node.return || null; hops++;
      }
    } catch (e) {}
    return null;
  }

  // Karten nach aktivem Tag ein-/ausblenden (alle Karten, inkl. Easify-Duplikate).
  function applyFilter() {
    var cat = ffPriming ? '' : ffActiveCat; // beim Vorladen alles sichtbar (Scroll braucht volle Höhe)
    var cards = document.querySelectorAll('easify-box-set [data-product-id]');
    for (var i = 0; i < cards.length; i++) {
      var show = !cat;
      if (!show) { var tags = ffCardTags(cards[i]); show = !!(tags && tags.indexOf(cat) !== -1); }
      if (show) cards[i].classList.remove('ff-bundle-cat-hidden');
      else cards[i].classList.add('ff-bundle-cat-hidden');
    }
  }

  // Überschrift über dem Raster folgt der Pill: bei „Alle“ der Easify-Text („Alle Produkte“),
  // sonst das Pill-Label. Es ist das letzte sichtbare Easify-HEADING vor der ersten Karte.
  // Den Originaltext merken wir uns am Element; geändert wird nur der Wert des Textknotens,
  // damit React seinen Knoten behält. Zeichnet Easify neu, setzt scan() den Text erneut.
  function applyHeading() {
    var firstCard = document.querySelector('easify-box-set [data-product-id]');
    if (!firstCard) return;
    var heads = document.querySelectorAll('easify-box-set [el-type="HEADING"]');
    var h = null;
    for (var i = 0; i < heads.length; i++) {
      if (heads[i].offsetParent === null) continue;
      if (heads[i].compareDocumentPosition(firstCard) & Node.DOCUMENT_POSITION_FOLLOWING) h = heads[i];
    }
    if (!h) return;
    var w = document.createTreeWalker(h, NodeFilter.SHOW_TEXT, null), tn = null, n;
    while ((n = w.nextNode())) { if (n.nodeValue.trim()) { tn = n; break; } }
    if (!tn) return;
    if (!h.hasAttribute('data-ff-heading-default')) h.setAttribute('data-ff-heading-default', tn.nodeValue);
    var label = h.getAttribute('data-ff-heading-default');
    for (var c = 0; c < FF_FILTER_CATS.length; c++) {
      if (ffActiveCat && FF_FILTER_CATS[c].tag === ffActiveCat) label = FF_FILTER_CATS[c].label;
    }
    if (tn.nodeValue !== label) tn.nodeValue = label;
    // Großbuchstaben wie die Kategorie-Überschrift (.ff-availability-pills__title). Per CSS nicht
    // möglich: Easify setzt text-transform:none !important in einem Cascade-Layer.
    var holder = tn.parentElement;
    if (holder.style.getPropertyValue('text-transform') !== 'uppercase') holder.style.setProperty('text-transform', 'uppercase', 'important');
  }

  // Lade-Overlay: verdeckt das (nötige) Prime-Durchscrollen beim 1. Filter-Klick, damit die
  // Seite nicht sichtbar springt — statt Scroll sieht man kurz einen „lädt…"-Spinner.
  function ffShowLoading(show) {
    var ov = document.querySelector('.ff-bundle-loading');
    if (show) {
      if (!ov) {
        ov = document.createElement('div');
        ov.className = 'ff-bundle-loading';
        var sp = document.createElement('span');
        sp.className = 'ff-bundle-loading__spinner';
        ov.appendChild(sp);
        document.body.appendChild(ov);
      }
      void ov.offsetWidth; // Reflow → Fade-in greift
      ov.classList.add('is-visible');
    } else if (ov) {
      ov.classList.remove('is-visible');
    }
  }

  function ffOnPillClick(e) {
    ffActiveCat = e.currentTarget.getAttribute('data-ff-cat') || '';
    var pills = document.querySelectorAll('.ff-bundle-filter__pill');
    for (var i = 0; i < pills.length; i++) {
      if ((pills[i].getAttribute('data-ff-cat') || '') === ffActiveCat) pills[i].classList.add('is-active');
      else pills[i].classList.remove('is-active');
    }
    // Beim 1. Filter-Klick alle Karten vorladen (Prime scrollt durch — hinter dem Lade-Overlay
    // versteckt). Danach ist ffPrimed=true → Folge-Klicks filtern sofort ohne Overlay.
    var needsPrime = !ffPrimed;
    if (needsPrime) ffShowLoading(true);
    applyHeading();
    ffPrimeAllCards(function () { if (needsPrime) ffShowLoading(false); applyFilter(); });
  }

  // Easify rendert die Karten LAZY beim gradualen Scrollen (ein Viewport pro Schritt; ein
  // Sprung ans Ende überspringt Zwischen-Batches). Fürs client-seitige Filtern brauchen wir
  // ALLE Karten im DOM — sonst zeigt eine Kategorie nur die zufällig schon geladenen. Deshalb
  // EINMAL schnell durchscrollen (rendert alle, bleiben im DOM) und zur Ausgangsposition zurück.
  var ffPrimed = false;
  function ffPrimeAllCards(done) {
    if (ffPrimed) { if (done) done(); return; } // schon vorgeladen -> direkt filtern
    ffPrimed = true;
    ffPriming = true;
    var startY = window.scrollY;
    var lastCount = -1, stable = 0, steps = 0;
    // Karten-ANZAHL beobachten (nicht Seitenhöhe): stoppen, wenn nichts Neues mehr nachlädt.
    // 140ms Schritt-Abstand gibt Easify Zeit zu rendern (zu schnell → „Boden" vor dem Nachladen).
    var iv = setInterval(function () {
      window.scrollBy(0, 500);
      steps++;
      var count = document.querySelectorAll('easify-box-set [data-product-id]').length;
      if (count === lastCount) stable++; else { stable = 0; lastCount = count; }
      var atBottom = (window.innerHeight + window.scrollY) >= (document.body.scrollHeight - 5);
      if ((stable >= 4 && atBottom) || steps > 100) {
        clearInterval(iv);
        window.scrollTo(0, startY);
        ffPriming = false;
        if (done) done();
      }
    }, 140);
  }

  // Pills einmal rendern (vor Easifys Tab-Container). Idempotent; re-added falls Easify sie
  // beim Re-Render entfernt. Easifys native Tabs blendet followfood.css aus.
  function renderFilterPills() {
    var box = document.querySelector('easify-box-set');
    if (!box || box.querySelector('.ff-bundle-filter')) return;
    var tabContainer = box.querySelector('[class*="style1Header__container"]');
    if (!tabContainer) return; // Easify-Header noch nicht da
    var wrap = document.createElement('div');
    wrap.className = 'ff-bundle-filter';
    wrap.setAttribute('role', 'tablist');
    for (var i = 0; i < FF_FILTER_CATS.length; i++) {
      var cat = FF_FILTER_CATS[i];
      var pill = document.createElement('button');
      pill.type = 'button';
      pill.className = 'ff-bundle-filter__pill' + (cat.tag === ffActiveCat ? ' is-active' : '');
      pill.setAttribute('data-ff-cat', cat.tag);
      pill.textContent = cat.label;
      var triplet = tabColorFor(cat.label) || tabColorFor(cat.tag);
      if (triplet) pill.style.setProperty('--ff-pill', triplet);
      pill.addEventListener('click', ffOnPillClick);
      wrap.appendChild(pill);
    }
    tabContainer.parentNode.insertBefore(wrap, tabContainer);
    applyFilter(); // beim Laden NICHT vorladen — das passiert erst beim 1. Filter-Klick
  }

  function scan() {
    var cards = document.querySelectorAll('[data-product-id]:not([data-ff-enriched])');
    for (var i = 0; i < cards.length; i++) enrichCard(cards[i]);
    // Easify-Preise aufs Shop-Format „<Betrag> €" normalisieren (idempotent;
    // faengt auch re-renderte Preise)
    var prices = document.querySelectorAll('.PRODUCT_CARD_PRICE_LIST_TS');
    for (var j = 0; j < prices.length; j++) normalizePrice(prices[j]);
    styleCardTexts();
    styleAtcButton();
    styleSteppers();
    styleTabs();
    renderFilterPills();
    if (ffActiveCat) applyFilter(); // nur bei aktivem Filter re-applyen (im „Alle"-Zustand nichts zu tun)
    applyHeading();
    styleSummary();
    fixReviewCartIcon();
    cleanDiscountPct();
    enrichBoxReview();
    enrichQuickView();
  }

  var pending = false;
  function scheduleScan() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; scan(); });
  }

  function init() {
    scan();
    // Auf document.body beobachten (nicht nur easify-box-set): Das Quick-View-Overlay (#50)
    // rendert Easify als Portal AUSSERHALB von <easify-box-set> (div.dialog__sbb_dialog
    // am body). Ein auf easify-box-set begrenzter Observer verpasst das Overlay-Rendering.
    // scan() ist idempotent + rAF-debounced -> der breitere Scope ist unkritisch.
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) { scheduleScan(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });

    // Quick-View-Overlay (#50): Easify ÖFFNET das Overlay durch Klassen-Toggle (root ->
    // root_open) + React-Text-Update an bereits vorhandenem Portal-DOM — OHNE addedNodes.
    // Der childList-Observer oben feuert dabei nicht. Zuverlässiger Trigger ist der Klick
    // auf den View-Button: danach ein paar gestaffelte enrichQuickView-Versuche, bis der
    // Overlay-Content (Anker) gerendert ist. enrichQuickView ist idempotent (Anker- + Element-
    // Guards) -> Mehrfachaufrufe sind No-Ops. capture:true, falls Easify stopPropagation nutzt.
    document.addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest('.PRODUCT_CARD_VIEW_BUTTON_TS')) return;
      var tries = 0;
      var iv = setInterval(function () { enrichQuickView(); if (++tries >= 14) clearInterval(iv); }, 150);
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
